/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import React from "react";
import {Box, IconButton, Popover} from '@mui/material';

export default function ArgosPopover(props: any) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popper' : undefined;

  return (
    <div>
      <IconButton size={'small'} onClick={handleClick}>
        {props?.button}
      </IconButton>
      <Popover id={id} open={open} anchorEl={anchorEl} style={{zIndex: 1000}}
               keepMounted={true} onClose={() => setAnchorEl(null)}
               anchorOrigin={{
                 vertical: 'center',
                 horizontal: 'left',
               }}
               transformOrigin={{
                 vertical: 'center',
                 horizontal: 'right',
               }}
      >
        <Box sx={{border: 1, p: 1, bgcolor: 'background.paper'}}>
          {props?.children}
        </Box>
      </Popover>
    </div>
  );
}
